import { useQuery } from '@tanstack/react-query';
import { SearchService } from '../../services/generatedApi';

const useAutocomplete = (freetext: string) => {
  return useQuery(
    ['freetext', freetext],
    () =>
      SearchService.searchAutoComplete(freetext).then((response) => response),
    {
      enabled: !!freetext,
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 5 * 60,
      staleTime: 1000 * 5 * 60,
    }
  );
};

export default useAutocomplete;
